"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitIO = void 0;
const app_1 = require("@koopajs/app");
const splitio_1 = require("@splitsoftware/splitio");
class SplitIO extends app_1.Plugins.Abstract {
    constructor() {
        super();
        this.key = 'splitio';
        this._splitNames = [];
        this._userKey = 'unknown';
        this._userAttributes = {};
        this._isOn = false;
        this.selectors.set('isFlagActive', (state, rootState, props) => {
            if (props.flag) {
                if (state[props.flag]) {
                    if (state[props.flag].toUpperCase() === 'ON') {
                        return true;
                    }
                }
            }
            else {
                return console.warn('isFlagActive needs a flag attribute in props');
            }
            return false;
        });
        app_1.Bus.onConfigReady(({ splitio: { authorizationKey, splitNames = [] } }) => {
            if (!authorizationKey) {
                return console.warn('Splitio extension is activated but backend config did not provide a `splitio.authorizationKey` value');
            }
            this._authorizationKey = authorizationKey;
            this._splitNames = splitNames;
        });
        app_1.Bus.onUserReady(({ userId }) => {
            this._userKey = userId;
            this._init();
        });
    }
    _init() {
        this.dispatchRequest(); // In the store, change the state of the extension to isLoading
        if (!this._client) {
            this._client = splitio_1.SplitFactory({
                core: { authorizationKey: this._authorizationKey, key: this._userKey },
                startup: { readyTimeout: 1.5 }
            }).client();
            this._on();
        }
        return this;
    }
    async _refresh() {
        const treatments = this._client.getTreatments(this._splitNames, this._userAttributes);
        this.dispatchSuccess(treatments); // Update the store for the current extension
        return treatments;
    }
    _on() {
        if (this._isOn) {
            return;
        }
        this._client.on(this._client.Event.SDK_READY, this._refresh.bind(this));
        this._client.on(this._client.Event.SDK_UPDATE, this._refresh.bind(this));
        this._isOn = true;
        return this;
    }
    _off() {
        if (!this._isOn) {
            return;
        }
        this._client.off(this._client.Event.SDK_READY, this._refresh.bind(this));
        this._client.off(this._client.Event.SDK_UPDATE, this._refresh.bind(this));
        this._isOn = false;
        return this;
    }
}
exports.SplitIO = SplitIO;
//# sourceMappingURL=index.js.map